import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAuth } from '../../contexts/AuthContext';

export default function SuperAdminShell({ title, description, children, testId, wide = false, inbox = false }) {
  const navigate = useNavigate();
  const { setSuperAdminMode } = useAuth();

  useEffect(() => {
    setSuperAdminMode('super_admin');
  }, [setSuperAdminMode]);

  return (
    <div
      className={`${inbox ? 'px-4 md:px-6 lg:px-8 max-w-none' : wide ? 'max-w-[1600px]' : 'max-w-6xl'} p-6 md:p-8 lg:p-10 mx-auto animate-fade-in ${inbox ? 'pb-4' : ''}`}
      data-testid={testId || 'super-admin-section'}
    >
      <Button
        variant="ghost"
        className="mb-4 -ml-2"
        onClick={() => {
          setSuperAdminMode('company');
          navigate('/dashboard');
        }}
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to company view
      </Button>
      <div className={inbox ? 'mb-4' : 'mb-8'}>
        <h1 className="text-2xl md:text-3xl font-bold font-[Manrope] text-slate-900 dark:text-white">
          {title}
        </h1>
        {description && !inbox ? (
          <p className="text-slate-600 dark:text-slate-400 mt-1 max-w-3xl">{description}</p>
        ) : null}
      </div>
      {children}
    </div>
  );
}
